<div class="row m-0 p-2 mb-0 ev-savings-container h-100">
  <div class="card main-card mt-1">
    <div class="d-flex justify-content-between">
      <div class="ev-calculator-label p-3 pb-0">EV Savings Calculator</div>
      <div class="pt-3">
        <span
          [pTooltip]="tooltipContent"
          tooltipPosition="left"
          tooltipStyleClass="ev-tooltip"
          [escape]="false"
          style="cursor: pointer; display: inline-flex"
        >
          <svg width="24" height="24">
            <use
              [attr.xlink:href]="svgPath + 'sprite.svg#' + 'info-icon'"
            ></use>
          </svg>

          <ng-template #tooltipContent>
            <div class="tooltip-title">Assumptions</div>
            <hr class="my-2" />
            <ul class="tooltip-list">
              <li>Assuming Diesel price 90rs/ltr</li>
              <li>
                Electricity Unit Cost
                <ul>
                  <li>AC charging SCV, Three Wheeler - 10rs/kWh</li>
                  <li>DC charging SCV, Three Wheeler - 20rs/kWh</li>
                </ul>
              </li>
              <li>True Range considered - 160km's (Three Wheeler)</li>
            </ul>
            <div
              class="d-flex justify-content-center align-items-start gap-1 disclaimer-wrap mt-3"
            >
              <sup class="text-danger"> * </sup>
              <span class="disclaimer">
                Displayed savings reflect only variable fuel cost differences
                and are indicative in nature. For a comprehensive analysis,
                please contact us.
              </span>
            </div>
          </ng-template>
        </span>
      </div>
    </div>
    <div class="d-flex flex-row gap-3 ps-0 pt-0 p-2 pb-0 m-0 flex-grow-1">
      <div class="col-7 pb-3 ps-2">
        <div class="card p-2 mt-3 h-100 vehicle-calc">
          <form [formGroup]="form" class="row g-3">
            <div class="d-flex flex-wrap gap-3 px-4 mt-3 mb-0">
              <div class="flex-fill">
                <p-select
                  formControlName="vehicleType"
                  [options]="vehicleOptions"
                  placeholder="Select Vehicle Type"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="w-100"
                  class="vehicle-dropdown"
                ></p-select>
                <label for="role-label" class="vehicle-label">
                  Vehicle Type
                </label>
              </div>
              <div class="flex-fill position-relative">
                <p-select
                  formControlName="model"
                  [options]="modelOptions"
                  placeholder="Select Model"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="false"
                  [disabled]="!modelOptions.length"
                  styleClass="w-100"
                  class="model-dropdown"
                >
                </p-select>
                <label for="role-label" class="model-label">Model</label>
              </div>
              <div class="flex-fill position-relative">
                <p-select
                  formControlName="fuelType"
                  [options]="fuelTypeOptions"
                  placeholder="Select Fuel type"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="w-100"
                  class="model-dropdown"
                ></p-select>
                <label for="role-label" class="model-label">Fuel type</label>
              </div>
              <div class="flex-fill fuel-cost-wrapper position-relative">
                <div class="input-shell">
                  <input
                    type="text"
                    pInputText
                    formControlName="fuelCost"
                    placeholder="Enter Fuel Cost"
                    class="fuel-input"
                    (keypress)="allowOnlyNumbers($event)"
                    [class.invalid-input]="
                      form.controls['fuelCost'].invalid &&
                      form.controls['fuelCost'].touched
                    "
                  />
                  <span class="unit-inside">
                    {{ form.get('fuelType')?.value === 'CNG' ? '/kg' : '/L' }}
                  </span>
                  <label for="float-label" class="model-label">
                    Fuel Cost(₹)
                    <sup class="text-danger">*</sup>
                  </label>
                </div>

                <div class="error-container">
                  <small
                    *ngIf="
                      form.controls['fuelCost'].hasError('required') &&
                      form.controls['fuelCost'].touched
                    "
                    class="text-danger error-size"
                  >
                    Please enter a valid fuel cost
                  </small>
                  <small
                    *ngIf="
                      form.controls['fuelCost'].hasError('rangeError') &&
                      form.controls['fuelCost'].touched
                    "
                    class="text-danger error-size"
                  >
                    Fuel cost must be between ₹40 and ₹150
                  </small>
                </div>
              </div>
            </div>

            <div class="mt-0 px-4">
              <span
                class="fw-semibold"
                style="min-width: 90px; text-align: right"
              >
                <label for="dailyKm" class="form-label mb-3">
                  <span class="distance-label">
                    {{ isTractor ? 'Daily Hours:' : 'Daily Distance:' }}
                  </span>
                  <span class="distance-value">
                    {{ form.value.dailyKm }}
                    {{ isTractor ? 'h' : 'km' }}
                  </span>
                </label>
              </span>
              <p-slider
                id="dailyKm"
                formControlName="dailyKm"
                [min]="isTractor ? 1 : 15"
                [max]="isTractor ? 10 : 1000"
                [step]="isTractor ? 1 : 5"
                styleClass="flex-fill"
                name="dailyKm"
              ></p-slider>

              <div class="d-flex justify-content-between mt-1 distance-label">
                <small>{{ isTractor ? '1 h' : '15 km' }}</small>
                <small>{{ isTractor ? '10 h' : '1000 km' }}</small>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="col-5 pb-3 pe-3">
        <div
          class="card p-2 mt-3 text-center d-flex flex-column justify-content-center align-items-center h-100 monthly-saving"
        >
          <div class="saving-head mb-4">
            Save More on Every Mile with
            <span class="text-success">EV</span> Power.
          </div>
          <div class="mb-4">
            <span>
              <img
                [src]="svgPath + 'greenTickToc.svg'"
                width="15"
                height="16"
                alt="Total greenTickToc Icon"
              />
            </span>
            <span class="monthly-head"> Your Monthly Savings </span>
          </div>
          <div class="monthly-value mb-2">
            {{
              monthlySavings | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card main-card d-flex flex-row gap-0 row my-0 cost-analysis-wrapper"
  >
    <div class="cost-analysis pt-3 pb-2">Cost Analysis & Projections</div>
    <div
      [ngClass]="{
        'col-12 col-lg-5': !expandedChartId || expandedChartId !== 'monthly',
        'col-12 col-lg-10': expandedChartId === 'monthly',
      }"
      *ngIf="!expandedChartId || expandedChartId === 'monthly'"
    >
      <div class="card chart-card-border mt-0 mb-2">
        <div
          class="d-flex justify-content-between align-items-center p-2 chart-header"
        >
          <div class="line-chart-head p-1">Monthly Running Cost Comparison</div>
          <div>
            <button
              class="graph-button-outline ti-btn-primary sec-button bg-white border-0"
              (click)="toggleExpand('monthly')"
              pTooltip="{{
                expandedChartId === 'monthly' ? 'Collapse' : 'Expand'
              }}"
              tooltipPosition="bottom"
            >
              <svg width="20" height="20">
                <use
                  [attr.xlink:href]="
                    svgPath +
                    'sprite.svg#' +
                    (expandedChartId === 'monthly'
                      ? 'collapseChart'
                      : 'expandChart')
                  "
                ></use>
              </svg>
            </button>
          </div>
        </div>
        <div class="chart-container">
          <p-chart
            #monthlyChart
            type="line"
            [data]="monthlyChartData"
            [options]="monthlyChartOptions"
          ></p-chart>
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'col-12 col-lg-5': !expandedChartId || expandedChartId !== 'cumulative',
        'col-12 col-lg-10': expandedChartId === 'cumulative',
      }"
      *ngIf="!expandedChartId || expandedChartId === 'cumulative'"
    >
      <div class="card chart-card-border mt-0 mb-2">
        <div
          class="d-flex justify-content-between align-items-center p-2 chart-header"
        >
          <div class="line-chart-head p-1">Cumulative Savings Over Time</div>
          <div>
            <button
              class="graph-button-outline ti-btn-primary sec-button bg-white border-0"
              (click)="toggleExpand('cumulative')"
              pTooltip="{{
                expandedChartId === 'cumulative' ? 'Collapse' : 'Expand'
              }}"
              tooltipPosition="bottom"
            >
              <svg width="20" height="20">
                <use
                  [attr.xlink:href]="
                    svgPath +
                    'sprite.svg#' +
                    (expandedChartId === 'cumulative'
                      ? 'collapseChart'
                      : 'expandChart')
                  "
                ></use>
              </svg>
            </button>
          </div>
        </div>
        <div class="chart-container">
          <p-chart
            #cumulativeChart
            type="line"
            [data]="cumulativeChartData"
            [options]="cumulativeChartOptions"
          ></p-chart>
        </div>
      </div>
    </div>

    <div
      class="col-12 col-lg-2 ps-2 ps-lg-4 mt-3 mt-lg-1 d-flex flex-row flex-lg-column gap-2"
    >
      <div class="card d-flex one-year-savings text-center pt-1 small-card">
        <div class="d-flex justify-content-center align-items-center mt-2">
          <span>
            <svg width="20" height="20">
              <use
                [attr.xlink:href]="svgPath + 'sprite.svg#' + 'calendar-icon'"
              ></use>
            </svg>
          </span>
          <span class="year-head"> 1 Year </span>
        </div>
        <div class="year-value">
          {{
            yearlySavings.one | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
          }}
        </div>
        <div class="year-info">Annual Savings</div>
      </div>

      <div class="card d-flex five-year-savings text-center pt-1 small-card">
        <div class="d-flex justify-content-center align-items-center mt-2">
          <span>
            <svg width="20" height="20">
              <use
                [attr.xlink:href]="svgPath + 'sprite.svg#' + 'calendar-icon'"
              ></use>
            </svg>
          </span>
          <span class="year-head"> 5 Year </span>
        </div>
        <div class="year-value">
          {{
            yearlySavings.five | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
          }}
        </div>
        <div class="year-info">5-Years Savings</div>
      </div>

      <div class="card d-flex ten-year-savings text-center pt-1 small-card">
        <div class="d-flex justify-content-center align-items-center mt-2">
          <span>
            <svg width="20" height="20">
              <use
                [attr.xlink:href]="svgPath + 'sprite.svg#' + 'calendar-icon'"
              ></use>
            </svg>
          </span>
          <span class="year-head"> 10 Year </span>
        </div>
        <div class="year-value">
          {{
            yearlySavings.ten | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
          }}
        </div>
        <div class="year-info">10-years Savings</div>
      </div>
    </div>
  </div>
</div>
